import type { ExpenseMerchantReport } from "../../expense/types";

export type MerchantReportCacheValue = {
  items: ExpenseMerchantReport[];
  nextCursor: string | null;
  totalCount: number;
};

const CACHE_LIMIT = 12;
const cache = new Map<string, MerchantReportCacheValue>();

export const getMerchantReportCache = (key: string) => cache.get(key);

export const setMerchantReportCache = (
  key: string,
  value: MerchantReportCacheValue,
) => {
  cache.delete(key);
  cache.set(key, value);
  while (cache.size > CACHE_LIMIT) {
    cache.delete(cache.keys().next().value as string);
  }
};

export const resetMerchantReportCache = () => cache.clear();
